import React from 'react';
import { Button, Typography } from '@mui/material';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';

const BackButton = ({ onClick, text = 'Go Back', Icon = HiOutlineArrowNarrowLeft }) => {
    return (
        <Button onClick={onClick}>
            <Icon
                color="#191919"
                size={25}
            />
            <Typography sx={{ color: '#191919', fontSize: '16px', fontWeight: 600, marginLeft: '8px' }}>{text}</Typography>
        </Button>
    );
};

export default BackButton;
